import CollectionNameRemapping from '../lib/CollectionNameRemapping.json';

export const remapCollectionName = (collectionName: string): string => {
  const remappedName =
    CollectionNameRemapping[
      collectionName as keyof typeof CollectionNameRemapping
    ] || collectionName;
  return remappedName;
};
